import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "shadow-box p-shadow-4 p-mb-3" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre", -1)
const _hoisted_5 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "ctaType" }, "CTA", -1)
const _hoisted_7 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "label" }, "CTA Label", -1)
const _hoisted_9 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "url" }, "CTA URL", -1)
const _hoisted_11 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "heading" }, "Titulo 1", -1)
const _hoisted_13 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "subheading" }, "Titulo 2", -1)
const _hoisted_15 = { class: "p-field p-col-10 p-md-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "backgroundColor" }, "Color del fondo", -1)
const _hoisted_17 = { class: "p-field p-col-2 p-md-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "backgroundColor1" }, " ", -1)
const _hoisted_19 = { class: "p-field p-col-10 p-md-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "textColor" }, "Color del texto", -1)
const _hoisted_21 = { class: "p-field p-col-2 p-md-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "textColor1" }, " ", -1)
const _hoisted_23 = { class: "p-field p-col-12" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "Contenido", -1)
const _hoisted_25 = { class: "p-field-checkbox p-col-4 p-md-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "enabled" }, "Habilitado", -1)
const _hoisted_27 = { class: "p-field-checkbox p-col-4 p-md-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "enabled" }, "Countdown", -1)
const _hoisted_29 = { class: "p-field-checkbox p-col-4 p-md-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "enabled" }, "Hero Banner", -1)
const _hoisted_31 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "countries" }, "Visible para", -1)
const _hoisted_33 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "categories" }, "Categorías", -1)
const _hoisted_35 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "curses" }, "Cursos", -1)
const _hoisted_37 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "roles" }, "Perfil de Usuario", -1)
const _hoisted_39 = { class: "p-field p-col-12 p-md-6 p-lg-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Desde", -1)
const _hoisted_41 = { class: "p-field p-col-12 p-md-6 p-lg-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Hasta", -1)
const _hoisted_43 = { class: "p-field p-col-12 p-md-8" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "countries" }, "Países habilitados", -1)
const _hoisted_45 = {
  class: "p-field p-col-12 p-md-6",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "file" }, "Seleccione una imagen", -1)
const _hoisted_47 = { class: "p-field p-col-12 p-md-6 align-items-center" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "url" }, "O URL", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteBannerPreview = _resolveComponent("SiteBannerPreview")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_RestrictedHtmlEditor = _resolveComponent("RestrictedHtmlEditor")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: "Editor de banner",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => (_ctx.visible = $event)),
    style: {width: '70vw'}
  }, {
    footer: _withCtx(() => [
      ((_ctx.editableBanner.context === _ctx.SiteBannerContext.WWW))
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Probar en la web",
            icon: "pi pi-external-link",
            onClick: _ctx.openTestUrl,
            class: "p-button-text"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        label: "Cancelar",
        icon: "pi pi-times",
        onClick: _ctx.closeEditDialog,
        class: "p-button-text"
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Guardar",
        icon: "pi pi-check",
        onClick: _ctx.onSave,
        disabled: !_ctx.validData
      }, null, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_SiteBannerPreview, { banner: _ctx.editableBanner }, null, 8, ["banner"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputText, {
            id: "name",
            type: "text",
            modelValue: _ctx.editableBanner.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.editableBanner.name = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_SelectButton, {
            modelValue: _ctx.editableBanner.cta.type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editableBanner.cta.type = $event)),
            options: _ctx.ctaTypes,
            "option-label": "label",
            "option-value": "value"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_InputText, {
            id: "label",
            type: "text",
            modelValue: _ctx.editableBanner.cta.text,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editableBanner.cta.text = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_InputText, {
            id: "url",
            type: "url",
            modelValue: _ctx.editableBanner.cta.url,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editableBanner.cta.url = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_InputText, {
            id: "heading",
            type: "text",
            modelValue: _ctx.editableBanner.heading,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editableBanner.heading = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_InputText, {
            id: "subheading",
            type: "text",
            modelValue: _ctx.editableBanner.subheading,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.editableBanner.subheading = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_InputMask, {
            id: "backgroundColor",
            modelValue: _ctx.editableBanner.style.backgroundColor,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.editableBanner.style.backgroundColor = $event)),
            mask: "#******"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_ColorPicker, {
            id: "backgroundColor1",
            modelValue: _ctx.editableBanner.style.backgroundColor,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.editableBanner.style.backgroundColor = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_InputMask, {
            id: "textColor",
            modelValue: _ctx.editableBanner.style.color,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.editableBanner.style.color = $event)),
            mask: "#******"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_ColorPicker, {
            id: "textColor2",
            modelValue: _ctx.editableBanner.style.color,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.editableBanner.style.color = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode(_component_RestrictedHtmlEditor, {
            modelValue: _ctx.content,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.content = $event)),
            editorStyle: "height: 6em",
            class: "p-field p-col-12",
            maxLength: _ctx.contentMaxLength
          }, null, 8, ["modelValue", "maxLength"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Checkbox, {
            id: "enabled",
            modelValue: _ctx.editableBanner.enabled,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.editableBanner.enabled = $event)),
            binary: true
          }, null, 8, ["modelValue"]),
          _hoisted_26
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_Checkbox, {
            id: "showCountdown",
            modelValue: _ctx.editableBanner.showCountdown,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.editableBanner.showCountdown = $event)),
            binary: true
          }, null, 8, ["modelValue"]),
          _hoisted_28
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_Checkbox, {
            id: "isHeroBanner",
            modelValue: _ctx.editableBanner.isHeroBanner,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.editableBanner.isHeroBanner = $event)),
            binary: true
          }, null, 8, ["modelValue"]),
          _hoisted_30
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.editableBanner.context,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.editableBanner.context = $event)),
            options: _ctx.contextOptions,
            optionLabel: "label",
            optionValue: "value",
            placeholder: "Seleccione"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createVNode(_component_MultiSelect, {
            class: "ch-w100",
            modelValue: _ctx.editableBanner.categories,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.editableBanner.categories = $event)),
            options: _ctx.categories,
            optionLabel: "name",
            optionValue: "_id",
            display: "chip",
            placeholder: "Seleccionar Categorías"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createVNode(_component_MultiSelect, {
            class: "ch-w100",
            modelValue: _ctx.editableBanner.courses,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.editableBanner.courses = $event)),
            options: _ctx.products,
            optionLabel: "title",
            optionValue: "_id",
            "data-key": "_id",
            display: "chip",
            filter: true,
            placeholder: "Seleccionar Cursos"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createVNode(_component_MultiSelect, {
            class: "ch-w100",
            modelValue: _ctx.editableBanner.roles,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.editableBanner.roles = $event)),
            options: _ctx.rolesOptions,
            optionLabel: "label",
            optionValue: "value",
            "data-key": "value",
            display: "chip",
            filter: false,
            showToggleAll: false,
            placeholder: "Seleccionar"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createVNode(_component_Calendar, {
            id: "from",
            modelValue: _ctx.editableBanner.active.from,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.editableBanner.active.from = $event)),
            showTime: true,
            hourFormat: "12",
            showSeconds: false,
            showIcon: true,
            showButtonBar: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createVNode(_component_Calendar, {
            id: "to",
            modelValue: _ctx.editableBanner.active.to,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.editableBanner.active.to = $event)),
            showTime: true,
            hourFormat: "12",
            showSeconds: false,
            showButtonBar: true,
            showIcon: true,
            minDate: _ctx.editableBanner.active.from
          }, null, 8, ["modelValue", "minDate"])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createVNode(_component_CountrySelector, {
            modelValue: _ctx.editableBanner.countryCodes,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.editableBanner.countryCodes = $event)),
            multiple: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createVNode(_component_FileUpload, {
            class: "ch-fileupload",
            name: "file",
            mode: "basic",
            accept: "image/*",
            chooseLabel: "Agregar/Editar",
            customUpload: true,
            auto: true,
            onUploader: _ctx.onUpload,
            onUpload: _ctx.onUploaded
          }, null, 8, ["onUploader", "onUpload"])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _createVNode(_component_InputText, {
            id: "url",
            type: "url",
            modelValue: _ctx.editableBanner.image,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.editableBanner.image = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}